import { getLastDiff } from './generator.js';
import { getSql } from './editor.js';

/**
 * 复制到剪贴板
 * 使用 getSql 直接从 CodeMirror 实例获取文本
 */
export function copySQL(type = 'output') {
  const text = getSql(type);
  if (text) {
    navigator.clipboard.writeText(text).then(() => {
      console.log(`Copied ${type} to clipboard`);
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }
}

/**
 * 下载 SQL 文件
 * 使用 getSql 直接从 CodeMirror 实例获取文本
 */
export function downloadSQL(type, filename) {
  const content = getSql(type);
  
  if (!content || content.trim().length === 0) {
    console.warn('No content to download for:', type);
    return;
  }

  const blob = new Blob([content], { type: 'text/sql;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  
  // 必须将元素添加到 DOM 才能在某些浏览器中生效
  document.body.appendChild(a);
  a.click();
  
  // 点击后立即清理
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
}

export function exportJSON() {
  const data = JSON.stringify(getLastDiff(), null, 2);
  const blob = new Blob([data], { type: 'application/json' });
  triggerDownload(blob, 'sql-diff.json');
}

export function exportMD() {
  const data = getLastDiff().map(d => `- ${d.table}.${d.column || d.index || ''} ${d.op} (${d.risk})`).join('\n');
  const blob = new Blob([data], { type: 'text/markdown' });
  triggerDownload(blob, 'review.md');
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
}
